export default __webpack_public_path__ + "src/images/reports/landing-christin-hume-595752-unsplash.jpg";